import { JOB_WAITING, JOB_RUNNING, JOB_ERROR, JOB_COMPLETE } from './importJobs.constants';

// helpers to find jobs by a status
export const anyWaiting = jobs => jobs.find(o => o.status === JOB_WAITING);
export const anyRunning = jobs => jobs.find(o => o.status === JOB_RUNNING);
export const anyErrors = jobs => jobs.find(o => o.status === JOB_ERROR);
export const anyComplete = jobs => jobs.find(o => o.status === JOB_COMPLETE);



// WEBPACK FOOTER //
// ./src/utils/importJobs.js